export const roundBookingCount = (value: number): string => {
    const thresholds = [
        { limit: 20, round: (v: number) => v.toString() },
        { limit: 100, round: (v: number) => `${Math.floor(v / 5) * 5}+` },
        { limit: 1000, round: (v: number) => `${Math.floor(v / 50) * 50}+` },
        { limit: 10000, round: (v: number) => `${(Math.floor(v / 100) / 10).toFixed(1).replace(/\.0$/, '')}k+` },
        { limit: 20000, round: (v: number) => `${Math.floor(v / 1000)}k+` },
        { limit: 1000000, round: (v: number) => `${Math.floor(v / 1000)}k+` },
    ];

    for (const { limit, round } of thresholds) {
        if (value < limit) {
            return round(value)
                .replace(/\.0k\+$/, 'k+')
                .replace(/\.0M\+$/, 'M+');
        }
    }

    return `${Math.floor(value / 1000000)}M+`.replace(/\.0M\+$/, 'M+');
};
